module.exports = __webpack_public_path__ + "img/banner_image0.48529ef8.jpg";